import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private _layoutTopbarMenuActive = false;

  get layoutTopbarMenuActive(): boolean {
    return this._layoutTopbarMenuActive;
  }

  set layoutTopbarMenuActive(value: boolean) {
    this._layoutTopbarMenuActive = value;
  }
}
